"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useErrorReporting = useErrorReporting;
var _react = require("react");
var _axios = _interopRequireDefault(require("axios"));
var _constants = require("../../constants");
var _ = require("./");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function useErrorReporting(flagEndpoint, appId, dsn, appPrefix) {
  var requestSanitizer = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
  var responseSanitizer = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
  var sampleRate = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 1.0;
  var debug = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : true;
  (0, _react.useEffect)(function () {
    _axios.default.get(flagEndpoint).then(function (response) {
      var deploymentStage = response.data[_constants.ENV_STAGE];
      (0, _.initializeErrorReporting)(appId, dsn, appPrefix, requestSanitizer, responseSanitizer, sampleRate, debug, deploymentStage);
    }).catch(function () {
      return (
        // eslint-disable-next-line no-console
        console.error('Error reporting not enabled, missing stage')
      );
    });
  }, []); // eslint-disable-line
}